module.exports = __webpack_public_path__ + "img/49exp.371cd4e7.jpg";